import { Action, createReducer, on } from "@ngrx/store";
import {initialState, userModelEntityAdapter} from "./users.state";
import {UsersActions} from "./usersActions";

export const usersReducer = createReducer(
    initialState,
    on(UsersActions.subscribeToUser, (state, { userId }) => {
        const subscribedUserIds = [...state.subscribedToUserIds]
        subscribedUserIds.push(userId)
        return {
            ...state,
            subscribedToUserIds: subscribedUserIds
        }
    }),
    on(UsersActions.foundUser, (state, { user }) => {
      return userModelEntityAdapter.addOne(user, state);
    }),
    on(UsersActions.updatedUser, (state, { user }) => {
      return userModelEntityAdapter.updateOne(
          {
            id: user.id,
            changes: {
              profile_image_file_id: user.profile_image_file_id,
              display_name: user.display_name,
              tag_line: user.tag_line,
              last_coord: user.last_coord
            },
          },
          state,
      );
    }),
);
